import { Flex, Text } from "styles/utility-components";

import EllipsisText from "components/ui/tooltip/EllipsisText";
import UIcon from "lib/icons/untitled_ui/UIcon";

export const OptionIconMap = {
  framework: "grid01",
  buyer: "wallet02",
  supplier: "building07",
  lead: "wallet02",
  bid: "wallet02",
} as const;

export function EntityOption({
  label,
  dataType,
  badge,
  iconProps,
}: {
  label: string;
  dataType?: keyof typeof OptionIconMap;
  badge?: string;
  iconProps?: { color?: string; backgroundColor?: string };
}) {
  return (
    <Flex alignItems="center" gap={8} minWidth={0}>
      <UIcon
        icon={OptionIconMap[dataType || "buyer"]} // Default to "buyer" icon if dataType is not provided
        color={iconProps?.color ?? "sysPrimaryDefault"}
        background={{ color: iconProps?.backgroundColor ?? "sysPrimarySubtle" }}
      />
      <EllipsisText>{label}</EllipsisText>
      {badge && <Text description>{badge}</Text>}
    </Flex>
  );
}
